import IndustryType from "./industryType";
export default IndustryType;